import { hcr_buildParentTemplates } from "../hcr_buildParentTemplates";
import { HierarchyContextProps, IHierarchyActionAddHierarchyNodes } from "../interface";

/**
 * Merges hierarchy nodes into state and rebuilds parent templates when required.
 *
 * @param state - The current hierarchy context state.
 * @param action - The add-hierarchy-nodes action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_addHierarchyNodes = (
  state: HierarchyContextProps,
  action: IHierarchyActionAddHierarchyNodes,
): HierarchyContextProps => {
  const updatedHierarchyNodes = [
    ...state.hierarchyNodes.filter((hn) => !action.hierarchyNodes.find((h) => h.id === hn.id)),
    ...action.hierarchyNodes,
  ];

  return {
    ...state,
    hierarchyNodes: updatedHierarchyNodes,
    parentTemplates: state.hierarchy
      ? hcr_buildParentTemplates(state.hierarchy, updatedHierarchyNodes)
      : state.parentTemplates,
  };
};
